
//接口名称
var api = {
  get_price: '/api/common/quote',//查询报价
  disclaimer: '/api/common/disclaimer',//免责声明
  quoteList: '/api/common/quoteList',//获取已报价列表
  add1V1: '/api/common/add1V1',//添加联系我们
}

export default api;










// WEBPACK FOOTER //
// ./src/utils/api.js